/* kit-buybox.js - galeria y selector de kits */
(function(){
  'use strict';
  var root=document.querySelector('[data-kit-hero]'); if(!root) return;
  var gal=root.querySelector('[data-kit-gal]');
  if(gal){
    var track=gal.querySelector('[data-kit-gal-track]');
    var slides=[].slice.call(track.querySelectorAll('.kit-gal__slide'));
    var thumbs=[].slice.call(gal.querySelectorAll('.kit-gal__thumb'));
    var dots=[].slice.call(gal.querySelectorAll('.kit-gal__dot'));
    var idx=0,raf=null;
    var go=function(i){ i=Math.max(0,Math.min(slides.length-1,i)); track.scrollTo({left:track.clientWidth*i,behavior:'smooth'}); };
    var mark=function(i){ if(i===idx) return; idx=i; thumbs.forEach(function(t,n){ t.setAttribute('aria-current',n===i?'true':'false'); }); dots.forEach(function(d,n){ d.setAttribute('aria-current',n===i?'true':'false'); }); };
    track.addEventListener('scroll',function(){ if(raf) cancelAnimationFrame(raf); raf=requestAnimationFrame(function(){ mark(Math.round(track.scrollLeft/track.clientWidth)); }); },{passive:true});
    thumbs.forEach(function(t,n){ t.addEventListener('click',function(){ go(n); }); });
    dots.forEach(function(d,n){ d.addEventListener('click',function(){ go(n); }); });
    var p=gal.querySelector('[data-kit-gal-prev]'),nx=gal.querySelector('[data-kit-gal-next]');
    if(p) p.addEventListener('click',function(){ go(idx-1); });
    if(nx) nx.addEventListener('click',function(){ go(idx+1); });
  }
  var offers=[].slice.call(root.querySelectorAll('[data-kit-offer]'));
  var now=root.querySelector('[data-kit-now]'),old=root.querySelector('[data-kit-old]'),off=root.querySelector('[data-kit-off]');
  var input=root.querySelector('[data-kit-variant-input]');
  function apply(el){
    offers.forEach(function(o){ o.setAttribute('aria-checked','false'); o.setAttribute('tabindex','-1'); });
    el.setAttribute('aria-checked','true'); el.setAttribute('tabindex','0');
    var d={name:el.getAttribute('data-name'),now:el.getAttribute('data-now'),old:el.getAttribute('data-old'),off:el.getAttribute('data-off'),variant:el.getAttribute('data-variant')};
    if(now) now.textContent=d.now;
    if(old) old.textContent=d.old;
    if(off) off.textContent=d.off;
    if(input) input.value=d.variant;
    try{ var u=new URL(window.location.href); u.searchParams.set('variant',d.variant); window.history.replaceState({},'',u.toString()); }catch(e){}
    window.__kitOffer=d;
    try{ document.dispatchEvent(new CustomEvent('kit:offer',{detail:d})); }catch(e){}
  }
  offers.forEach(function(el,i){
    el.addEventListener('click',function(){ apply(el); });
    el.addEventListener('keydown',function(e){
      if(e.key===' '||e.key==='Enter'){ e.preventDefault(); apply(el); }
      else if(e.key==='ArrowDown'||e.key==='ArrowRight'){ e.preventDefault(); var n=offers[(i+1)%offers.length]; apply(n); n.focus(); }
      else if(e.key==='ArrowUp'||e.key==='ArrowLeft'){ e.preventDefault(); var m=offers[(i-1+offers.length)%offers.length]; apply(m); m.focus(); }
    });
  });
  var cur=root.querySelector('[data-kit-offer][aria-checked="true"]');
  if(cur) apply(cur); else if(offers[0]) apply(offers[0]);
})();